module.exports = __webpack_public_path__ + "static/img/goods-list-img01.dc7163d1.svg";